<template>
  <div id="login">
    <section class="bannerprincipal pb-5">
      <SiteNav v-if="showNav"></SiteNav>
      <div
        v-if="!showNav"
        class="col-12 text-center"
        data-aos="fade-down"
        data-aos-delay="100"
      ></div>

      <img
        class="w-100 d-block d-lg-none"
        src="../assets/imgs/foroprosa2024/foro2024_header_mobile.jpg"
        alt="Foro Prosa"
      />
      <img
        class="w-100 d-none d-lg-block"
        src="../assets/imgs/foroprosa2024/foro2024_header_desk.jpg"
        alt="Foro Prosa"
      />

      <div class="container">
        <div class="row">
          <div class="col-12 pt-md-5">
            <div class="row d-flex justify-content-center align-items-center">
              <div class="col-9">
                <div class="fG2 pb-2 bold">
                  20 &bull; SEP &bull; 2024 &bull; 08:30 hrs
                </div>
                <div class="separador mb-2"></div>
                <div class="fG bold">
                  Hotel Camino Real Polanco, Terraza Virreyes
                </div>
                <div>
                  <a
                    href="https://goo.gl/maps/MWsqZWbZLib6C9op9"
                    target="_blank"
                    >Ver mapa &raquo;</a
                  >
                </div>
              </div>
              <div class="col-3">
                <img
                  src="../assets/imgs/foroprosa2024/fecha-22-sep-2024.png"
                  alt="Foro Prosa"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="col-12 text-left pt-1 pt-md-0 mt-n4">
                <p class="fXG2 pb-2 morado bold">Mapa</p>
               
              </div> -->

      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-12 mapa">
                    <img
                      v-show="sala_activa == ''"
                      src="../assets/imgs/foroprosa2024/mapa/mapa.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '1DPlus'"
                      src="../assets/imgs/foroprosa2024/mapa/1DPlus.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '1D'"
                      src="../assets/imgs/foroprosa2024/mapa/1D.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '2D'"
                      src="../assets/imgs/foroprosa2024/mapa/2D.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '3D'"
                      src="../assets/imgs/foroprosa2024/mapa/3D.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '4D'"
                      src="../assets/imgs/foroprosa2024/mapa/4D.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '5D'"
                      src="../assets/imgs/foroprosa2024/mapa/5D.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '6D'"
                      src="../assets/imgs/foroprosa2024/mapa/6D.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '7D'"
                      src="../assets/imgs/foroprosa2024/mapa/7D.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '8D'"
                      src="../assets/imgs/foroprosa2024/mapa/8D.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '9D'"
                      src="../assets/imgs/foroprosa2024/mapa/9D.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '10D'"
                      src="../assets/imgs/foroprosa2024/mapa/10D.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />

                    <img
                      v-show="sala_activa == '1P'"
                      src="../assets/imgs/foroprosa2024/mapa/1P.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '2P'"
                      src="../assets/imgs/foroprosa2024/mapa/2P.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '3P'"
                      src="../assets/imgs/foroprosa2024/mapa/3P.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '4P'"
                      src="../assets/imgs/foroprosa2024/mapa/4P.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '5P'"
                      src="../assets/imgs/foroprosa2024/mapa/5P.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '6P'"
                      src="../assets/imgs/foroprosa2024/mapa/6P.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '7P'"
                      src="../assets/imgs/foroprosa2024/mapa/7P.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '8P'"
                      src="../assets/imgs/foroprosa2024/mapa/8P.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '9P'"
                      src="../assets/imgs/foroprosa2024/mapa/9P.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '10P'"
                      src="../assets/imgs/foroprosa2024/mapa/10P.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '11P'"
                      src="../assets/imgs/foroprosa2024/mapa/11P.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '12P'"
                      src="../assets/imgs/foroprosa2024/mapa/12P.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '1Or'"
                      src="../assets/imgs/foroprosa2024/mapa/1Or.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />
                    <img
                      v-show="sala_activa == '2Or'"
                      src="../assets/imgs/foroprosa2024/mapa/2Or.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />

                    <img
                      v-show="sala_activa == '3Or'"
                      src="../assets/imgs/foroprosa2024/mapa/3Or.jpg"
                      alt="Foro Prosa"
                      class="imgmapa"
                    />

                    <div class="overlay">
                      <img
                        src="../assets/imgs/foroprosa/mapa/pin_mapa.png"
                        alt="Foro Prosa"
                        class="pin"
                        v-bind:class="'pin' + sala_activa"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row">
              <div class="col-12 py-4 py-lg-5">
                <div class="row">
                  <div class="col-12 fG">
                    <b>Selecciona</b> un stand o sala para resaltar en el mapa.
                  </div>

                  <div class="col-12 py-4 fCe">
                    <div class="row">
                      <div class="col-6 col-md-3">
                        <div class="row no-gutters">
                          <div class="opcionessalas">
                            <img
                              width="120"
                              src="../assets/imgs/foroprosa2024/mapa/DiamantePlus.png"
                              alt="tipo"
                              class="img-fluid mb-3"
                            />
                            <div
                              class="cursor"
                              @click="highlight('1DPlus')"
                              v-bind:class="{ active: sala_activa == '1DPLUS' }"
                            >
                              <b class="small bold">1D PLUS</b> DISCOVER
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-6 col-md-3">
                        <div class="row no-gutters">
                          <div class="opcionessalas">
                            <img
                              width="120"
                              src="../assets/imgs/foroprosa2024/mapa/Diamante.png"
                              alt="tipo"
                              class="img-fluid mb-3"
                            />
                            <div
                              class="cursor"
                              @click="highlight('1D')"
                              v-bind:class="{ active: sala_activa == '1D' }"
                            >
                              <b class="small bold">1D</b> VIERGE GROUP
                            </div>
                            <div
                              class="cursor"
                              @click="highlight('2D')"
                              v-bind:class="{ active: sala_activa == '2D' }"
                            >
                              <b class="small bold">2D</b> ACI WORLDWIDE
                            </div>
                            <div
                              class="cursor"
                              @click="highlight('3D')"
                              v-bind:class="{ active: sala_activa == '3D' }"
                            >
                              <b class="small bold">3D</b> INGENICO
                            </div>
                            <div
                              class="cursor"
                              @click="highlight('4D')"
                              v-bind:class="{ active: sala_activa == '4D' }"
                            >
                              <b class="small bold">4D</b> VERIFONE
                            </div>
                            <div
                              class="cursor"
                              @click="highlight('5D')"
                              v-bind:class="{ active: sala_activa == '5D' }"
                            >
                              <b class="small bold">5D</b> VERITRAN
                            </div>
                            <div
                              class="cursor"
                              @click="highlight('6D')"
                              v-bind:class="{ active: sala_activa == '6D' }"
                            >
                              <b class="small bold">6D</b> SEPROCESA + CYTTEK
                            </div>
                            <div
                              class="cursor"
                              @click="highlight('7D')"
                              v-bind:class="{ active: sala_activa == '7D' }"
                            >
                              <b class="small bold">7D</b> FLUID ATTACKS + INFINYT
                            </div>
                            <div
                              class="cursor"
                              @click="highlight('8D')"
                              v-bind:class="{ active: sala_activa == '8D' }"
                            >
                              <b class="small bold">8D</b> SOFTTEK
                            </div>
                            <div
                              class="cursor"
                              @click="highlight('9D')"
                              v-bind:class="{ active: sala_activa == '9D' }"
                            >
                              <b class="small bold">9D</b> NEWLAND
                            </div>
                            <div
                              class="cursor"
                              @click="highlight('10D')"
                              v-bind:class="{ active: sala_activa == '10D' }"
                            >
                              <b class="small bold">10D</b> A3SEC
                            </div>
                            
                          </div>
                        </div>
                        <div class="row mt-2 no-gutters">
                          <div class="hlplatino opcionessalas"></div>
                        </div>
                      </div>

                      <div class="col-6 col-md-3">
                        <div class="row no-gutters">
                          <div class="col-12 opcionessalas">
                            <img
                              width="120"
                              src="../assets/imgs/foroprosa2024/mapa/Platino.png"
                              alt="tipo"
                              class="img-fluid mb-3"
                            />
                            <div
                              class="cursor"
                              @click="highlight('1P')"
                              v-bind:class="{ active: sala_activa == '1P' }"
                            >
                              <b class="small bold">1P</b> AKAMAI
                            </div>
                            <div
                              class="cursor"
                              @click="highlight('2P')"
                              v-bind:class="{ active: sala_activa == '2P' }"
                            >
                              <b class="small bold">2P</b> THALES
                            </div>
                            <div
                              class="cursor"
                              @click="highlight('3P')"
                              v-bind:class="{ active: sala_activa == '3P' }"
                            >
                              <b class="small bold">3P</b> ACCENTURE
                            </div>
                            <div
                              class="cursor"
                              @click="highlight('4P')"
                              v-bind:class="{ active: sala_activa == '4P' }"
                            >
                              <b class="small bold">4P</b> DS PREAD
                            </div>
                            <div
                              class="cursor"
                              @click="highlight('5P')"
                              v-bind:class="{ active: sala_activa == '5P' }"
                            >
                              <b class="small bold">5P</b> G&D
                            </div>
                            <div
                              class="cursor"
                              @click="highlight('6P')"
                              v-bind:class="{ active: sala_activa == '6P' }"
                            >
                              <b class="small bold">6P</b> FEXCO
                            </div>
                          </div>

                          <div class="col-12 opcionessalas">
                            <div
                              class="cursor"
                              @click="highlight('7P')"
                              v-bind:class="{ active: sala_activa == '7P' }"
                            >
                              <b class="small bold">7P</b> BLUERITY + TIC DEFENSE
                            </div>
                          </div>

                          <div class="col-12 opcionessalas">
                            <div
                              class="cursor"
                              @click="highlight('8P')"
                              v-bind:class="{ active: sala_activa == '8P' }"
                            >
                              <b class="small bold">8P</b> CHECKPOINT + DATAWARDEN
                            </div>
                          </div>

                          <div class="col-12 opcionessalas">
                            <div
                              class="cursor"
                              @click="highlight('9P')"
                              v-bind:class="{ active: sala_activa == '9P' }"
                            >
                              <b class="small bold">9P</b> FUTUREX
                            </div>
                          </div>

                          <div class="col-12 opcionessalas">
                            <div
                              class="cursor"
                              @click="highlight('10P')"
                              v-bind:class="{ active: sala_activa == '10P' }"
                            >
                              <b class="small bold">10D</b> SAILPOINT
                            </div>
                          </div>

                          <div class="col-12 opcionessalas">
                            <div
                              class="cursor"
                              @click="highlight('11P')"
                              v-bind:class="{ active: sala_activa == '11P' }"
                            >
                              <b class="small bold">11D</b> EVERTEC
                            </div>
                          </div>

                          <div class="col-12 opcionessalas">
                            <div
                              class="cursor"
                              @click="highlight('12P')"
                              v-bind:class="{ active: sala_activa == '12P' }"
                            >
                              <b class="small bold">12D</b> HEY TECH
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-6 col-md-3">
                        <div class="row no-gutters">
                          <div class="opcionessalas"></div>
                        </div>

                        <div class="row mt-2 no-gutters">
                          <div class="col-12 opcionessalas mb-2">
                            <img
                              width="120"
                              src="../assets/imgs/foroprosa2024/mapa/Oro.png"
                              alt="tipo"
                              class="img-fluid mb-3"
                            />
                            <div
                              class="cursor"
                              @click="highlight('1Or')"
                              v-bind:class="{ active: sala_activa == '1Or' }"
                            >
                              <b class="small bold">1</b> PARABILIUM
                            </div>

                            <div
                              class="cursor"
                              @click="highlight('2Or')"
                              v-bind:class="{ active: sala_activa == '2Or' }"
                            >
                              <b class="small bold">2</b> ELLIPSE
                            </div>
                            <div
                              class="cursor"
                              @click="highlight('3Or')"
                              v-bind:class="{ active: sala_activa == '3Or' }"
                            >
                              <b class="small bold">3</b> UTIMACO
                            </div>
                          </div>

                          
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-12">
                    <div class="row fG">
                      <div class="col-12" v-show="sala_activa == '6D'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/verisec.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        <p>
                          Desarrolla e implementa servicios avanzados de
                          infraestructura de cifrado para optimizar la seguridad
                          de plataformas de Banca Móvil y WEB, Cajeros
                          Automáticos, Redes de Pago, entre otros. Nuestros
                          servicios están diseñados para satisfacer, a GRAN
                          escala, las necesidades de las organizaciones que
                          procesan millones de transacciones diarias en entornos
                          de aplicaciones altamente críticas con las que prestan
                          servicios financieros a millones de clientes.
                        </p>
                      </div>

                      <div class="col-12" v-show="sala_activa == '2D'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/vierge.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        <p>
                          Atiende industrias como la financiera, gobierno,
                          telecomunicaciones, educación y salud, con proyectos
                          de alcance regional que van desde la implementación de
                          soluciones core hasta la optimización de soluciones
                          digitales pasando por el desarrollo y gestión de redes
                          de pagos móviles.
                        </p>
                      </div>

                      <div class="col-12" v-show="sala_activa == '9D'">
                        <p>
                          <img
                            width="200"
                            src="../assets/imgs/foroprosa/empresas/discover.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        <p>
                          Discover® Global Network, la marca de pagos globales
                          de Discover Financial Services, procesa millones de
                          transacciones de titulares de tarjetas cada día. Con
                          experiencia en la industria, tecnología innovadora y
                          una infraestructura de ciclo cerrado, Discover Global
                          Network brinda soluciones efectivas y personalizadas
                          que evolucionan a medida que cambian las necesidades.
                          Discover Global Network tiene alianzas con más de 25
                          redes de pago en todo el mundo y está dirigida por
                          tres empresas de Discover:
                        </p>
                        <p>
                          Discover Network, con millones de puntos de venta
                          minorista y ubicaciones de acceso a efectivo; PULSE®,
                          una de las principales redes de cajeros
                          automáticos/débito en los Estados Unidos; y Diners
                          Club International®, una red global de pagos con
                          aceptación en más de 200 países y territorios.
                        </p>
                      </div>

                      <div class="col-12" v-show="sala_activa == '10D'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/logo_pnw_alt.png"
                            alt="Foro Prosa"
                          />
                        </p>
                        <p>
                          Nos encargamos de utilizar tecnologías avanzadas,
                          conocimientos patentados y algoritmos para resolver
                          los complejos problemas de pagos junto con su potencia
                          de procesamiento, alto nivel de seguridad y
                          escalabilidad lo convierten en un socio de pagos
                          confiable. Nuestros servicios de pagos en tiempo real
                          y nuestras ofertas de capacidades de pagos inmediatos
                          para la industria financiera y no bancaria les
                          permiten contar con un centro de pagos sólido para una
                          experiencia de pagos muy satisfactoria.
                        </p>
                      </div>

                      <div class="col-12" v-show="sala_activa == '4D'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/prosa.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        <p>
                          #SomosProsa, empresa de tecnología líder en el
                          ecosistema de pagos electrónicos en México, estamos
                          dentro del top 10 de América Latina al procesar más de
                          8,000 transacciones anuales en nuestro Switch,
                          beneficiando a más de 70 millones de usuarios de
                          tarjetas.
                        </p>
                        <p>
                          Tenemos la convicción de generar soluciones
                          innovadoras, eficientes, seguras y ágiles para los
                          participantes en el ecosistema de medios de pago,
                          manteniendo la alta disponibilidad de nuestros
                          servicios.
                        </p>
                        <p>
                          Nuestra infraestructura y seguridad está respaldada
                          por certificaciones como PCI DSS, PCI PIN, ISO
                          9001:2015, ISO 270001:2013.
                        </p>
                        <br />
                        <p>
                          <img
                            width="90"
                            src="../assets/imgs/foroprosa/empresas/carnet.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        <p>
                          Carnet, marca mexicana líder de aceptación,
                          permitiendo a las entidades emisoras ganar respaldo y
                          confianza a través de su red de aceptación en
                          comercios físicos, digitales y cajeros automáticos.
                        </p>
                      </div>
                      <div class="col-12" v-show="sala_activa == '12D'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/a3sec.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        Somos #GuerrerosDIgitales y estamos convencidos de que
                        los buenos siempre tenemos que ganar. Nos apasiona la
                        velocidad de transformación y generación de conocimiento
                        de la 4ª revolución. Nuestro objetivo es blindar tus
                        activos digitales por medio de soluciones que generan
                        prevención, detección y reacción.
                      </div>
                      <div class="col-12" v-show="sala_activa == '11D'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/aci.png"
                            alt="Foro Prosa"
                          />
                        </p>
                        Líder en pagos en tiempo real, ofrece soluciones de
                        software de pagos en tiempo real de misión crítica que
                        permiten a las corporaciones procesar y administrar
                        pagos digitales, potenciar los pagos comerciales de
                        manera Omni Canal, presentar y procesar pagos de
                        facturas y administrar el fraude y el riesgo.
                      </div>
                      <div class="col-12" v-show="sala_activa == '5D'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/verifone.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        Verifone es el arquitecto de pagos líder en el mundo,
                        desde dispositivos de pago hasta herramientas de
                        e-Commerce. Como empresa Fintech, Verifone impulsa el
                        crecimiento del comercio omnicanal en más de 165 países
                        y cuenta con la confianza de las marcas, pequeñas
                        empresas y las principales instituciones financieras en
                        el mundo. La plataforma Verifone se basa en innovación y
                        seguridad gestionando anualmente más de 12,000 millones
                        de transacciones por valor de más de $500,000 millones
                        en canales físicos y digitales.
                      </div>
                      <div class="col-12" v-show="sala_activa == '8D'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/veritran.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        Somos una compañía global de tecnología, cuyo objetivo
                        es colaborar, mediante soluciones digitales de negocio,
                        con las instituciones financieras para llevar su
                        digitalización al siguiente nivel.
                      </div>
                      <div class="col-12" v-show="sala_activa == '3D'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/ingenico.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        Ayudamos a nuestros clientes a navegar por el nuevo
                        mundo del comercio, en el que la verticalización, la
                        expansión de los servicios, y los agentes digitales
                        están transformando el panorama de pagos. Somos el socio
                        de confianza tanto de instituciones financieras y
                        cadenas de retail como de los pequeños comercios,
                        ofreciendo a todos soluciones de pago sencillas y
                        confiables.
                      </div>
                      <div class="col-12" v-show="sala_activa == '4P'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/thales.png"
                            alt="Foro Prosa"
                          />
                        </p>
                        Líder mundial en seguridad que invierte en innovaciones
                        digitales y tecnología profunda brindando soluciones,
                        servicios y productos que ayudan a los clientes a
                        cumplir con las exigencias actuales del mercado
                        Financiero
                      </div>
                      <div class="col-12" v-show="sala_activa == '2P'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/tenable-certezsa.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        <p>
                          Tenable es la empresa de gestión de la exposición.
                          Como creador de Nessus®, Tenable amplió su experiencia
                          en vulnerabilidades para ofrecer la primera plataforma
                          del mundo para ver y asegurar cualquier activo digital
                          en cualquier plataforma informática.
                        </p>
                        <p>
                          Certezsa: Empresa mexicana innovadora y especializada
                          en servicios de Seguridad de la Información y
                          Ciberseguridad que siguen estándares nacionales e
                          internacionales basados en un modelo de servicios
                          propio y de vanguardia con la finalidad de obtener
                          resultados de valor, que permitan reducir los riesgos
                          en las organizaciones y así facilitar la toma de
                          decisiones.
                        </p>
                      </div>
                      <div class="col-12" v-show="sala_activa == '1P'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/gyd.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        G+D es una empresa alemana, basada en Munich, presente
                        en 33 países con más de 103 subsidiarias y empresas
                        conjuntas, que ha sido socio confiable de las
                        instituciones más exigentes desde 1852. Hoy, nuestro
                        objetivo sigue siendo generar confianza en un mundo
                        digital, protegiendo la vida de millones de personas en
                        todo el mundo. Diseñamos tecnologías de seguridad
                        personalizadas con pasión y precisión en cuatro campos
                        principales: pagos, conectividad, identidades e
                        infraestructuras digitales.
                      </div>
                      <div class="col-12" v-show="sala_activa == '5P'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/solopago.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        Proveedor de dispositivos de pago electrónico, que
                        satisfacen las necesidades de cualquier sector, y de
                        soluciones de tecnologías innovadoras que generan valor
                        y dan ventajas competitivas a nuestros clientes.
                      </div>

                      <div class="col-12" v-show="sala_activa == '8P'">
                        <p>
                          <img
                            width="200"
                            src="../assets/imgs/foroprosa/empresas/insside-tycomm.jpg"
                            alt="Foro Prosa"
                          />
                        </p>
                        <p>
                          Insside: Desde 2007 brindamos soluciones de seguridad
                          de la información, diseñadas para ayudar a las
                          organizaciones a desarrollar entornos ciberseguros,
                          con menos riesgos y protegiendo sus activos críticos.
                        </p>
                        <p>
                          Tycomm: Nuestro principal objetivo es brindar la mejor
                          calidad de desarrollo de software a nuestros clientes
                          para que ellos se enfoquen en sus negocios, así como
                          incrementar la seguridad de la información de las
                          empresas y ofrecer la consultoría de PCI, ISO, todo en
                          un solo dashboard multinorma.
                        </p>
                      </div>

                      <div class="col-12" v-show="sala_activa == '9P'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/checkpoint.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        Proveedor líder de soluciones de ciberseguridad para
                        empresas y gobiernos de todo el mundo. La cartera de
                        soluciones de Check Point Infinity protege a las
                        empresas y organizaciones públicas de los ciberataques
                        de 5ª generación con una tasa de captura líder en la
                        industria de malware, ransomware y otras amenazas.
                        Infinity se compone de cuatro pilares fundamentales que
                        ofrecen una seguridad sin compromisos y una prevención
                        de amenazas de quinta generación en todos los entornos
                        empresariales: Check Point Harmony, para usuarios
                        remotos; Check Point CloudGuard, para proteger
                        automáticamente los entornos cloud; Check Point Quantum,
                        para proteger los perímetros de la red y los centros de
                        datos, todo ello controlado por la gestión de seguridad
                        unificada más completa e intuitiva de la industria; y
                        Check Point Horizon, una suite de operaciones de
                        seguridad que da prioridad a la prevención. Check Point
                        Software protege a más de 100.000 organizaciones de
                        todos los tamaños.
                      </div>
                      <div class="col-12" v-show="sala_activa == '6P'">
                        <p>
                          Realsec: Durante 40 años, fabricante de soluciones de
                          ciberseguridad basadas HSMs locales y como servicio,
                          gestión de claves, protección de datos, gestión de
                          identidades, soluciones de inteligencia de datos para
                          infraestructuras críticas reguladas y sistemas de
                          alerta pública. Con presencia a nivel mundial y
                          garantizando el máximo nivel de integridad y
                          protección de datos ayudando a nuestros clientes a
                          poder ofrecer soluciones seguras y certificadas frente
                          a los peligros del ciberespacio.
                        </p>

                        <p>
                          Linko: En Linko, con 20 años de experiencia, brindamos
                          soluciones en desarrollo, integración, ciberseguridad,
                          automatización y analítica a grandes corporativos.
                          Adaptamos servicios a tus necesidades, ofreciendo
                          innovación para eficiencia y rentabilidad. Socios
                          confiables en un mercado desafiante."
                        </p>
                      </div>
                      <div class="col-12" v-show="sala_activa == '10P'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/imperva.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        Imperva es el líder en ciberseguridad integral que tiene
                        la misión de ayudar a las organizaciones a proteger sus
                        datos y todos los procesos que involucren información.
                        Imperva protege todas las experiencias digitales, desde
                        la lógica empresarial hasta las APIs, los microservicios
                        y las diferentes capas de datos empresariales, tanto
                        desde los entornos vulnerables y heredados hasta las
                        organizaciones que dan prioridad a la nube.
                      </div>
                      <div class="col-12" v-show="sala_activa == '3P'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/my-card.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        Empresa mexicana especializada en la fabricación de
                        tarjetas plásticas con 30 años de experiencia cumpliendo
                        con los estándares internacionales de calidad.
                      </div>
                      <div class="col-12" v-show="sala_activa == '1Or'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/akamai.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        Akamai potencia y protege la vida online. Empresas
                        líderes de todo el mundo eligen Akamai para construir,
                        entregar y proteger sus experiencias digitales, ayudando
                        a miles de millones de personas a vivir, trabajar y
                        jugar cada día. Akamai Connected Cloud, una plataforma
                        en el edge y en la nube, distribuida de forma masiva,
                        acerca las aplicaciones y experiencias a los usuarios y
                        mantiene las amenazas más alejadas.
                      </div>
                      <div class="col-12" v-show="sala_activa == '7P'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/bluerity.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        <p>
                          Bluerity: Empresa dedicada a la ciberseguridad
                          especializada en las disciplinas de apoyo en el
                          desarrollo del ámbito tecnológico y empresarial.
                        </p>

                        <p>
                          TIC Defense: Especialistas en soluciones de
                          ciberseguridad innovadoras e integrales para
                          salvaguardar los activos más estratégicos: procesos,
                          factor humano y tecnología, permitiendo establecer un
                          ecosistema de ciberseguridad robusto y logrando la
                          ciber-resiliencia organizacional.
                        </p>
                      </div>
                      <div class="col-12" v-show="sala_activa == '3Or'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/copayment.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        Especialistas en la industria que ofrece sistemas de
                        pagos transaccionales como Switch Emisor, Switch
                        Agregador y soluciones RPA para aclaraciones y
                        contracargos.
                      </div>
                      <div class="col-12" v-show="sala_activa == '2Or'">
                        <p>
                          <img
                            width="150"
                            src="../assets/imgs/foroprosa/empresas/futurex.svg"
                            alt="Foro Prosa"
                          />
                        </p>
                        Durante más de 43 años, Futurex ha sido proveedor
                        confiable de soluciones de seguridad de clase
                        empresarial para más de 15.000 organizaciones en todo el
                        mundo. Proveedores de servicios financieros y empresas
                        corporativas han confiado en los innovadores módulos de
                        seguridad de hardware, servidores de gestión de llaves y
                        soluciones en la nube de clase empresarial de Futurex
                        para abordar sus sistemas de misión crítica, la
                        seguridad de los datos y las necesidades criptográficas.
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import SiteNav from "@/components/SiteNav";
import PasswordReset from "@/components/PasswordReset";

import router from "../router/index";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

import { mapState } from "vuex";

export default {
  components: {
    Footer,
    SiteNav,
  },
  data() {
    return {
      mensaje_reenvio: "",
      torneo_db: false,
      clinica_db: false,
      comida_db: false,
      reenvioForm: {
        codigo: "",
      },
      loginForm: {
        no_cliente: "",
        password: "",
      },
      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        telefono: "",
        movil: "",
        ext: "",
        terminos: false,
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      id: null,
      sala_activa: "",
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    this.id = this.$route.params.id;
    console.log({ id: this.id });

    if (this.id != undefined && this.id != "" && this.id != null) {
      this.sala_activa = this.id;
    }
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      //return Object.keys(this.userProfile).length > 1;
      return true;
    },
  },
  methods: {
    nuevocodigo() {
      this.reenvioForm.codigo = "";
    },
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      this.$store.dispatch("showLoader", true);

      e.preventDefault();

      const https = require("https");
      var qData = {
        no_cliente: this.loginForm.no_cliente,
        email: this.loginForm.email,
        password: this.loginForm.password,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "login2.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              localStorage.setItem(
                "user_foroprosa_2023",
                JSON.stringify(res.usuario)
              );

              router.push("/");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.signupForm.codigo = res.datos[0].codigo;
              this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1.toUpperCase();
              this.signupForm.nombre_2 = res.datos[0].nombre_2.toUpperCase();
              this.signupForm.apellido_paterno =
                res.datos[0].apellido_paterno.toUpperCase();
              this.signupForm.apellido_materno =
                res.datos[0].apellido_materno.toUpperCase();
              this.signupForm.empresa = res.datos[0].empresa.toUpperCase();
              this.signupForm.puesto = res.datos[0].puesto.toUpperCase();
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              if (res.datos[0].tipo == "PATROCINADOR") {
                //
                this.signupForm.clinica = res.datos[0].clinica;
                this.signupForm.torneo = res.datos[0].torneo;
                this.signupForm.comida = res.datos[0].comida;
                this.signupForm.tipo = res.datos[0].tipo;

                this.torneo_db = res.datos[0].torneo;
                this.clinica_db = res.datos[0].clinica;
                this.comida_db = res.datos[0].comida;

                if (this.signupForm.torneo == "SI") {
                  this.signupForm.evento = "Torneo";
                }
                if (this.signupForm.clinica == "SI") {
                  this.signupForm.evento = "Clínica";
                }
              }

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio() {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        telefono: "",
        movil: "",
        ext: "",
        terminos: false,
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
    changeEvento(e) {
      if (this.signupForm.evento == "Clínica") {
        this.signupForm.clinica = "SI";
        this.signupForm.torneo = "NO";
      } else if (this.signupForm.evento == "Torneo") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "SI";
      } else if (this.signupForm.evento == "Ninguno") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "NO";
      }
      this.signupForm.talla_guantes = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeComida(e) {
      if (this.signupForm.comida == "NO") {
        this.signupForm.torneo = "NO";
        this.signupForm.clinica = "NO";
      }
      this.signupForm.talla_guantes = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeTorneo(e) {
      if (this.signupForm.torneo === "SI") {
        this.signupForm.clinica = "NO";
        this.signupForm.talla_guantes = "";
      } else {
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      }
    },
    changeClinica(e) {
      if (this.signupForm.clinica === "SI") {
        this.signupForm.torneo = "NO";
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      } else {
        this.signupForm.talla_guantes = "";
      }
    },
    quitarAcentos(elemento) {
      //console.log('quitando acentos')
      elemento = elemento.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      //console.log({elemento})
      return elemento;
    },
    highlight(sala) {
      this.sala_activa = sala;
      const mapaElement = document.querySelector('.mapa');
      if (mapaElement) {
        // Calculate the position of the element minus the offset of 100px
        const offsetTop = mapaElement.getBoundingClientRect().top + window.scrollY - 180;
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      }
    },
  },
};
</script>
